module.exports = __webpack_public_path__ + "layout_com2.jpg?0d1db3a7e0f0675b69172a4165f28c24";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layouts/layout_com2.jpg
// module id = 83
// module chunks = 0